<template>
  <div class="index-container">
    <!-- 顶部导航栏 -->
    <div class="nav-header">
      <div class="logo">全民跳绳赛事管理系统</div>
      <div class="nav-links">
        <el-menu :default-active="activeIndex" class="nav-menu" mode="horizontal" background-color="#409EFF"
          text-color="#fff" active-text-color="#fff" @select="handleSelect" router>
          <el-menu-item index="/contestant/match-list">首页</el-menu-item>
          <el-menu-item index="/contestant/personal-center">个人中心</el-menu-item>
          <el-menu-item index="/contestant/team-manage">团队管理</el-menu-item>
          <el-menu-item index="/contestant/competition-record">参赛记录</el-menu-item>
        </el-menu>
      </div>
      <div class="user-info">
        <el-dropdown placement="bottom-end" trigger="hover">
          <div class="content-div">
            <!-- <img class="user-avatar" src="../../assets/default-header-icon.png" /> -->
            <div class="user-name" v-if="userInfo">{{ userInfo.LoginName }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-setting" v-if="userInfo.AccountType == 0 || userInfo.AccountType == 2"
              @click.native="toManageIndex">后台管理</el-dropdown-item>
            <el-dropdown-item icon="el-icon-edit" @click.native="editPwdOnclick">修改密码</el-dropdown-item>
            <el-dropdown-item :divided="true" icon="el-icon-switch-button"
              @click.native="loginoutOnclick()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <el-scrollbar class="main-scrollbar hidden-el-overflow-x">
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-scrollbar>
    </div>

    <el-dialog title="修改密码" :visible.sync="editPwdObj.visible" width="500px" @close="editPwdObj.visible = false">
      <el-form :model="editPwdObj.dataForm" v-loading="editPwdObj.loading" label-width="100px"
        v-if="updatePwdType=='pwd'">
        <el-form-item label="旧密码">
          <el-input show-password v-model="editPwdObj.dataForm.oldPwdStr" placeholder="请输入旧密码"></el-input>
          <div style="text-align: right;text-decoration: underline;cursor: pointer;">
            <span @click="changeOprType('code')">短信验证</span>
          </div>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input show-password v-model="editPwdObj.dataForm.newPwdStr" placeholder="新密码至少8位数" @input="verifyPwd"
            @change="verifyPwd"></el-input>
          <span style="display: block; margin: 3px 0;color: #999;font-size: 12px;">数字、大写字母、小写字母、特殊字符至少包含3种</span>
          <el-progress :percentage="pwdFormatStep" :show-text="false" :status="pwdFormatStepStatus"></el-progress>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input show-password v-model="editPwdObj.dataForm.cNewPwdStr" placeholder="请再次输入密码"></el-input>
        </el-form-item>

      </el-form>

      <el-form style="width: 85%;" v-if="updatePwdType == 'code'" label-width="100px">
        <el-form-item label="手机号">
          <span v-if="userInfo.AccPhone == ''" style="color: red;">请先在个人中心绑定手机号</span>
          {{ userInfo.AccPhone }}
          <div style="text-align: right;text-decoration: underline;cursor: pointer;">
            <span @click="changeOprType('pwd')">旧密码验证</span>
          </div>
        </el-form-item>
        <el-form-item label="图片验证码">
          <img style="position: absolute; z-index: 100;width: 100px;height: 35px;right: 5px;top: 4px;"
            @click="createRandomCodeImage()" class="code-image" :src="codeFilePath" />
          <el-input type="text" v-model="editPwdObj.dataForm.imageCode" placeholder="图片验证码" maxlength="6"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码">
          <el-input type="text" v-model="editPwdObj.dataForm.code" placeholder="短信验证码" maxlength="6"></el-input>
          <el-button class="code-btn" type="text" :disabled="'发送验证码' != btnText"
            style="position: absolute;right: 5px;top: 0;" @click="sendMobileCodeByAccId">{{
            btnText }}</el-button>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input show-password v-model="editPwdObj.dataForm.newPwdStr" placeholder="新密码至少8位数" @input="verifyPwd"
            @change="verifyPwd"></el-input>
          <span style="display: block; margin: 3px 0;color: #999;font-size: 12px;">数字、大写字母、小写字母、特殊字符至少包含3种</span>
          <el-progress :percentage="pwdFormatStep" :show-text="false" :status="pwdFormatStepStatus"></el-progress>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input show-password v-model="editPwdObj.dataForm.cNewPwdStr" placeholder="请再次输入密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="editPwdSubmitOnclick">修 改</el-button>
        <el-button size="small" @click="editPwdObj.visible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UserInfoService from "@/request-server/request-services/userinfo-services.js";
import contestantServices from "@/request-server/request-services/contestant-services.js";
import systemServices from "@/request-server/request-services/system-services.js";
import Url from '@/request-server/request-url';
export default {
  data() {
    return {
      // 数据可以在这里定义
      activeIndex: '/users/match-list',
      userInfo:{},
      editPwdObj: {
        visible: false,
        loading: false,
        dataForm: {
          oldPwdStr: '',
          newPwdStr: "",
          cNewPwdStr: "",
          code:'',
          imageCode:''
        }
      },
      pwdFormatStep: 0,
      pwdFormatStepStatus: 'exception',
      updatePwdType:'pwd',
      btnText:'',
      codeId:'',
      codeFilePath:'',
      lockSecond: 0,
      interval: null
    }
  },
  created() {
    this.activeIndex = this.$route.path;
    this.loadUserInfo();
    this.getUnitInfo();
     // 监听路由变化
     this.$router.afterEach((to) => {
      this.activeIndex = to.path;
    });
  },
  methods: {
    loadUserInfo(){
      UserInfoService.getUserInfo().then(resData=>{
          if(resData.code == 0){
            this.userInfo = resData.data;
            this.$store.commit("updateUserInfo", resData.data);
          }
      })
    },
    getUnitInfo() {
      contestantServices.getUnitInfo().then(resData => {
        console.log(resData);
        if (resData.data) {
          this.$store.commit("updateUnitInfo", resData.data);
        }
      })
    },
    // 方法可以在这里定义
    handleSelect() { },
    toManageIndex() {
      this.$router.replace("/mainpage");
    },
    loginoutOnclick() {
      this.$store.commit("loginout");
      this.$router.replace("/login");
    },
    changeOprType(type){
      this.updatePwdType = type;
      if(type == 'code'){
        //获取图片验证码
        this.createRandomCodeImage();
        this.btnText = '发送验证码'
      }
    },
    //修改密码点击事件
    editPwdOnclick() {
      this.editPwdObj.visible = true;
      this.editPwdObj.dataForm.oldPwdStr = "";
      this.editPwdObj.dataForm.newPwdStr = "";
      this.editPwdObj.dataForm.cNewPwdStr = "";
      this.updatePwdType = 'pwd';
    },
    verifyPwd() {
      let formatSucc = 0;
      let lenSucc = 0;

      if (/\d/.test(this.editPwdObj.dataForm.newPwdStr)) formatSucc++;
      if (/[a-z]/.test(this.editPwdObj.dataForm.newPwdStr)) formatSucc++;
      if (/[A-Z]/.test(this.editPwdObj.dataForm.newPwdStr)) formatSucc++;
      if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.editPwdObj.dataForm.newPwdStr)) formatSucc++;

      if (this.editPwdObj.dataForm.newPwdStr.length >= 8) lenSucc = 1;
      let formatStep = formatSucc >= 3 ? 75 : formatSucc * 25;
      this.pwdFormatStep = formatStep + lenSucc * 25;

      this.pwdFormatStepStatus = this.pwdFormatStep == 100 ? 'success' : 'warning'
    },
    //修改密码提交点击事件
    editPwdSubmitOnclick() {
      let oPwd = this.editPwdObj.dataForm.oldPwdStr;
      let nPwd = this.editPwdObj.dataForm.newPwdStr;
      let cPwd = this.editPwdObj.dataForm.cNewPwdStr;
      let code = this.editPwdObj.dataForm.code;
      if (this.updatePwdType == 'pwd' && !oPwd) {
        this.$message.warning("请输入旧密码");
        return;
      }

      if (this.updatePwdType == 'code' && !code) {
        this.$message.warning("请输入短信验证码");
        return;
      }

      if (typeof nPwd === "undefined" || !nPwd) {
        this.$message.warning("请输入新密码");
        return;
      }

      if (this.pwdFormatStep < 100) {
        this.$message.warning("新密码格式不正确");
        return;
      }

      if (typeof cPwd === "undefined" || !cPwd) {
        this.$message.warning("请输入确认新密码");
        return;
      }
      if (nPwd !== cPwd) {
        this.$message.warning("新密码和确认新密码不一致");
        return;
      }

      let data = {
        Type: this.updatePwdType,
        OldPwd: oPwd,
        NewPwd: nPwd,
        Code:code
      }

      this.editPwdObj.loading = true;
      UserInfoService.editPasswordV2(data)
        .then(res => {
          this.editPwdObj.visible = false;
          this.$message.success("修改密码成功");
          this.loginoutOnclick();
        })
        .finally(() => {
          this.editPwdObj.loading = false;
        });
    },
    sendMobileCodeByAccId() {
      if(this.userInfo.AccPhone == ''){
        this.$message.warning('请先绑定手机号');
        return;
      }
      if (this.editPwdObj.dataForm.imageCode == '') {
        this.$message.warning('请输入图片验证码');
        return;
      }

      let data = {
        codeId: this.codeId,
        code: this.editPwdObj.dataForm.imageCode,
        type: 'update-pwd'
      }
      UserInfoService.sendMobileCodeByAccId(data).then(resData => {
        if (resData.code == 0) {
          this.lockSecond = 60;
          this.btnText = this.lockSecond + 's';
          this.interval = setInterval(() => {
            if (this.lockSecond > 0) {
              this.lockSecond--;
              this.btnText = this.lockSecond + 's';
            } else {
              this.btnText = '发送验证码';
              clearInterval(this.interval);
              this.interval = null;
            }
          }, 1000);
        }
      })
    },
    createRandomCodeImage() {
      this.codeId = '';
      this.base64Str = '';
      systemServices.createRandomCodeImage().then(resData => {
        if (resData.code === 0) {
          this.codeId = resData.data.code;
          this.codeFilePath = Url.getDownloadBaseUrl() + 'exportfiles/' + resData.data.fileName;
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.index-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F4F4F4;
}

/* 顶部导航栏样式 */
.nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 20px;
  background-color: #409EFF;
  color: #fff;
}

.logo {
  font-size: 36px;
  font-family: 'PangMenChenDao', sans-serif;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-item {
  color: #fff;
  text-decoration: none;
  padding: 0 10px;
  font-size: 18px;
  height: 60px;
  line-height: 60px;
  box-sizing: border-box;

  &.active {
    // font-weight: bold;
    background-color: #409EFF;
    opacity: 0.8;
  }

  &:hover {
    // text-decoration: underline;
    background-color: rgba(255, 255, 255, 0.2);
  }
}

.user-info,
.content-div {
  display: flex;
  gap: 18px;
  font-size: 16px;
  cursor: pointer;
  .user-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }

  .user-name {
    color: #fff;
    text-decoration: none;
    display: block;
    height: 45px;
    line-height: 45px;
  }
}

/* 主要内容区域样式 */
.main-content {
  height: 90vh;
  overflow: hidden;
  overflow-y: auto;
}

.is-active {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.main-scrollbar {
  width: 100%;
  overflow-x: hidden;
}

.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
</style>
